import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce7e9de8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/logos/Logo_Woonon.jpg",
  width: "140",
  alt: "Logo Woonon"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Inloggen bij Woonon", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gebruikersnaam", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Wachtwoord", -1))

import { authStore } from '@/stores/auth'
import { onBeforeMount, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { errorNotification } from '@/functions/notification'
import SecureLS from 'secure-ls'
import axios from 'axios'
import { headerStore } from '@/stores/header'
import { generalStore } from '@/stores/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const auth = authStore()
const route = useRoute()
const router = useRouter()
const ls = new SecureLS({ isCompression: false })
const username = ref('')
const password = ref('')
const loading = ref(false)

onBeforeMount(() => {
  if (auth.loggedIn) {
    redirectTo()
  }
})

function login () : void {
  loading.value = true
  auth.login(username.value, password.value).then(() => {
    loading.value = false
    redirectTo()
  }).catch((e:{ response: { status:number } }) => {
    console.log(e)
    if (e.response.status && e.response.status === 401) {
      errorNotification(
        'Onjuiste combinatie van gebruikernaam en wachtwoord.',
        'De door u ingevulde combinatie van gebruikersnaam en wachtwoord is onjuist. Probeer het nogmaals.'
      )
    } else {
      errorNotification(
        'Inloggen mislukt.',
        'Er is iets mis gegaan. Probeer het later nogmaals.'
      )
    }
  }).finally(() => {
    loading.value = false
  })
}

function redirectTo () : void {
  if (ls.get('buildings').length === 1) {
    ls.set('building', ls.get('buildings')[0])
    axios.post(process.env.VUE_APP_API_URL + '/building/set', { bid: ls.get('buildings')[0].id }).then((r) => {
      ls.set('bid', ls.get('buildings')[0].id)
      ls.set('demoAccount', ls.get('buildings')[0].projectReference + '@woonon.nl')
      authStore().setDemoEnvironment(r.data.demo)
      headerStore().getOrdersReceived()
      headerStore().checkIfExtraPhaseIsEnabled()
      headerStore().checkIfServiceIsEnabled()

      if (route.query.redirect && typeof route.query.redirect === 'string') {
        router.push({ path: route.query.redirect })
      } else {
        router.push({ name: 'Dashboard' })
      }
    }).catch((e) => {
      console.log(e)
    })
  } else if (ls.get('buildings').length > 1) {
    router.push({ name: 'BuildingSelector' })
  } else {
    errorNotification('Geen bouwnummers gevonden!', 'Er zijn voor uw account geen bouwnummers gevonden.')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_row, { style: {"height":"100vh","margin":"0"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12,
        xl: 16,
        class: "login-image"
      }),
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12,
        xl: 8,
        style: {"padding":"64px 16px"}
      }, {
        default: _withCtx(() => [
          (_unref(generalStore)().appSettings?.notification?.pages.includes('Login'))
            ? (_openBlock(), _createBlock(_component_a_row, {
                key: 0,
                style: {"margin-bottom":"64px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 20,
                    offset: 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_alert, {
                        type: "info",
                        class: "global-notification",
                        message: _unref(generalStore)().appSettings.notification.title,
                        "show-icon": ""
                      }, {
                        description: _withCtx(() => [
                          _createElementVNode("div", {
                            innerHTML: _unref(generalStore)().appSettings.notification.description
                          }, null, 8, _hoisted_1)
                        ]),
                        _: 1
                      }, 8, ["message"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_row, { style: {"margin-bottom":"64px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 20,
                offset: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 20,
                offset: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createVNode(_component_a_input, {
                            type: "text",
                            value: username.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_5,
                          _createVNode(_component_a_input_password, {
                            value: password.value,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                            onKeyup: _withKeys(login, ["enter"])
                          }, null, 8, ["value", "onKeyup"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            class: "fw-btn",
                            style: {"margin-bottom":"16px"},
                            loading: loading.value,
                            onClick: login
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Inloggen")
                            ]),
                            _: 1
                          }, 8, ["loading"]),
                          _createVNode(_component_a_button, {
                            type: "link",
                            class: "fw-btn",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'ForgotPassword' })))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Wachtwoord vergeten?")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})